var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgTransfer(props) {
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 25 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M14.614 1L18.5 4.886l-3.886 3.886 M1.013 10.715V8.772A3.886 3.886 0 014.9 4.886h13.6M10.387 21L6.5 17.114l3.886-3.886 M23.987 11.286v1.943a3.886 3.886 0 01-3.886 3.885h-13.6", stroke: "#023365" })));
}
export default SvgTransfer;
